// Toast
import { Suspense, useEffect, useState } from 'react'
import 'react-toastify/dist/ReactToastify.css'
// router
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'

import AppToast from 'general/components/AppToast'
import DataCommonListener from 'general/listeners/DataCommonListener'
// router
import PrivateRoute from 'general/components/Routes/PrivateRoute'

import store from 'app/store'
import OutPutEInvoice from 'features'
import AccountListener from 'features/Account/AccountListener'
import KTPageError01 from 'general/components/OtherKeenComponents/KTPageError01'
import { injectStore } from 'general/helpers/WebSocketHelper'

import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { hideNotification } from 'app/appSlice'
import GuestSignInvoiceReport from 'features/Invoice/screens/GuestSignInvoiceReport'
import Search from 'features/Search'
import NotificationModal from 'general/components/Modal/NotificationModal'
import { useDispatch, useSelector } from 'react-redux'
// Load BS
require('bootstrap/dist/js/bootstrap.min')
// Load KT plugins
require('assets/plugins/ktutil')
require('assets/plugins/ktmenu')
require('assets/plugins/ktoffcanvas')
require('assets/plugins/ktcookie')
require('assets/plugins/kttoggle')
// aside
require('assets/plugins/aside/aside')
require('assets/plugins/aside/aside-menu')
require('assets/plugins/aside/aside-toggle')
// header
require('assets/plugins/header/ktheader-mobile')
require('assets/plugins/header/ktheader-topbar')
// dayjs
import dayjs from 'dayjs'
import 'dayjs/locale/vi'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import lf from 'dayjs/plugin/localizedFormat'
import quarter from 'dayjs/plugin/quarterOfYear'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import ForgotPassword from 'features/Auth/screens/ForgotPassword'
import LoginHomeScreen from 'features/Auth/screens/LoginHomeScreen'
import ResetPassword from 'features/Auth/screens/ResetPassword'
import GuestSignTicketReport from 'features/Invoice/screens/GuestSignTicketReport'
import GuestRoute from 'general/components/Routes/GuestRoute'
import useProjectBranding from 'hooks/useProjectBranding'
import SignUpScreen from 'features/Auth/screens/SignUpScreen'
import {
  ButtonSave,
  ButtonTutorial,
  DivColFooter,
  DivFooter,
  DivRowFooter,
  ModalWrapper,
  ModalWrapperTool,
  StyleButtonClose,
} from 'features/TaxDeduction/styled'
import { useTranslation } from 'react-i18next'
import SSO from 'features/SSO'
import InPutEInvoice from 'features/InPutEInvoice'
import useRouter from 'hooks/useRouter'

// Load the timezone and UTC plugins
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.extend(lf)
dayjs.extend(customParseFormat)
dayjs.extend(quarter)
dayjs.extend(relativeTime)
dayjs.extend(duration)

// Set the default time zone to +07:00
dayjs.tz.setDefault('Asia/Ha_Noi')
dayjs.locale('vi') // use locale globally

window.$ = window.jQuery = require('jquery')
window.moment = require('moment')
window.dayjs = dayjs

function App() {
  const dispatch = useDispatch()
  const { navigate } = useRouter()
  const { pathname } = useLocation()
  const { appSpinning, appNotificationModalShow, appNotificationInfo } =
    useSelector((state) => state.app)
  useEffect(() => {
    // console.log(`${sTag} did load`);
    injectStore(store)
    return () => {
      // console.log(`${sTag} will dismiss`);
    }
  }, [])

  useProjectBranding()
  const { t } = useTranslation()
  const [inforSettingTool, setInforSettingTool] = useState({ show: false })

  async function handleDownloadApp(closepopup) {
    if (closepopup) {
      setInforSettingTool({ show: false })
    } else {
      let donwloadUrl = `${process.env.REACT_APP_BASE_URL}/resources/einvoice_tool/${window.location.hostname == 'hoadon.gohoadon.vn' ? 'GoInvoiceSign.msi' : 'vietinvoiceSign.msi'}`
      window.open(donwloadUrl)
    }
  }

  useEffect(() => {
    if (!process.env.REACT_APP_WIDGETUID) {
      return
    }

    // Cấu hình widget trước khi load script
    window.AMIS_CHAT_CONFIG = {
      widgetUid: process.env.REACT_APP_WIDGETUID,
      showToggleButton: true,
    }

    const scripts = [
      'https://widget.icorp.vn/suport-widget.js',
      'https://widget.icorp.vn/purchase-widget.js',
      'https://widget.icorp.vn/widget.js',
    ]

    const loadedScripts = []

    scripts.forEach((src) => {
      // Tránh load script nhiều lần
      if (document.querySelector(`script[src="${src}"]`)) {
        return
      }

      const script = document.createElement('script')
      script.src = src
      script.async = false
      script.dataset.amisWidget = 'true'

      document.body.appendChild(script)
      loadedScripts.push(script)
    })

    setTimeout(() => {
      refetchWIDGET()
    }, 500)

    return () => {
      // Nếu muốn widget chỉ tồn tại trong vòng đời App
      loadedScripts.forEach((script) => {
        script.remove()
      })
    }
  }, [])

  useEffect(() => {
    refetchWIDGET()
  }, [pathname])

  async function refetchWIDGET() {
    if (process.env.REACT_APP_WIDGETUID) {
      const launcher = document.getElementById('amisAtcSupportLauncher')
      const amisMenuTrigger = document.getElementById('amisMenuTrigger')

      if (launcher) {
        if (pathname.includes('/dang-nhap')) {
          launcher.style.removeProperty('display')
        } else {
          launcher.style.display = 'none'
        }
      }
      if (amisMenuTrigger) {
        if (pathname.includes('/dang-nhap')) {
          amisMenuTrigger.style.setProperty('display', 'none', 'important')
        } else {
          amisMenuTrigger.style.removeProperty('display')
        }
      }
    }
  }

  return (
    <Spin
      spinning={appSpinning}
      className="vw-100 vh-100"
      style={{
        maxHeight: 'none',
        position: 'fixed',
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
      }}
      size="large"
      indicator={<LoadingOutlined style={{ fontSize: 100 }} spin />}
    >
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/*" element={<Navigate to="/hoa-don-dau-ra" />} />

          {/* hop dong dien tu */}
          <Route
            path="/hoa-don-dau-ra/*"
            element={
              <PrivateRoute>
                <OutPutEInvoice />
              </PrivateRoute>
            }
          />

          <Route
            path="/dang-nhap"
            element={<Navigate to={'/auth/dang-nhap'} replace />}
          />
          <Route path="/auth" element={<GuestRoute />}>
            <Route index element={<Navigate to={'dang-nhap'} replace />} />
            <Route path="dang-nhap" element={<LoginHomeScreen />} />
            <Route path="quen-mat-khau" element={<ForgotPassword />} />
            <Route path="dat-lai-mat-khau" element={<ResetPassword />} />
            <Route path="dang-ky/*" element={<SignUpScreen />} />
          </Route>

          <Route path="/tra-cuu" element={<Search />} />

          <Route
            path="/bien-ban-huy/ky/:invoiceId"
            element={<GuestSignInvoiceReport />}
          />
          <Route
            path="/bien-ban-thay-the/ky/:invoiceId"
            element={<GuestSignInvoiceReport />}
          />

          <Route
            path="/bien-ban-dieu-chinh/ky/:invoiceId"
            element={<GuestSignInvoiceReport />}
          />

          <Route
            path="/tem-ve/bien-ban-huy/ky/:ticketId"
            element={<GuestSignTicketReport />}
          />
          <Route
            path="/tem-ve/bien-ban-thay-the/ky/:ticketId"
            element={<GuestSignTicketReport />}
          />

          <Route
            path="/tem-ve/bien-ban-dieu-chinh/ky/:ticketId"
            element={<GuestSignTicketReport />}
          />

          <Route path={'/sso'} element={<SSO />} />

          <Route path="*" element={<KTPageError01 />} />
        </Routes>
      </Suspense>
      {/* Toast */}
      <AppToast />
      {/* Notification modal */}
      <NotificationModal
        title={appNotificationInfo?.title}
        describeText={appNotificationInfo?.describeText}
        icon={appNotificationInfo?.icon}
        show={appNotificationModalShow}
        onClose={() => dispatch(hideNotification())}
      />
      {/* Listener */}
      <DataCommonListener />
      <AccountListener />
      <button
        style={{ display: 'none' }}
        id="viewSettingTool"
        onClick={() => {
          setInforSettingTool({ show: true })
        }}
      >
        viewSettingTool
      </button>
      <input id="data_navigate" style={{ display: 'none' }} />
      <button
        style={{ display: 'none' }}
        id="view_navigate"
        onClick={() => {
          navigate(document.getElementById('data_navigate').value)
        }}
      >
        view_navigate
      </button>

      <ModalWrapperTool
        title={t('tool.title')}
        open={inforSettingTool.show}
        onCancel={() => setInforSettingTool({ show: false })}
        width={650}
        footer={
          <DivFooter>
            <DivRowFooter className="row">
              <DivColFooter className="col-6"></DivColFooter>
              <DivColFooter className="col-6" justifyContent={'right'}>
                <ButtonSave
                  style={{ backgroundColor: '#49b454' }}
                  type="primary"
                  onClick={() => {
                    handleDownloadApp(1)
                  }}
                >
                  {t('tool.yes')}
                </ButtonSave>
              </DivColFooter>
            </DivRowFooter>
          </DivFooter>
        }
      >
        <span style={{ color: '#5e6166' }}>
          {window.location.hostname == 'hoadon.gohoadon.vn'
            ? t('tool.messageGo')
            : t('tool.message')}{' '}
        </span>
        <span
          style={{ color: '#5f91c4', cursor: 'pointer' }}
          onClick={() => {
            handleDownloadApp()
          }}
        >
          {t('tool.setting')}
        </span>
      </ModalWrapperTool>
    </Spin>
  )
}

export default App
